import Page from "../pages/Decks";
import { pageMeta } from "../lib/meta";
import { OG_IMAGE } from "../config/heroArt";
export const meta = () => pageMeta({ title: "Slide Decks | Gazar", description: "Every slide deck from the lightning lessons, the LLM and agent cohorts and the senior-to-staff course. Free to read, no sign-up.", path: "/decks", image: OG_IMAGE.lessons });
export default function R() { return <Page />; }
